import styles from "../../styles/education/Certificate.module.css";
import useUserContext from "../auth/useUserContext";

export default function Certificate(props) {
    const { certificateRef } = props;
    const { userProfile } = useUserContext();

    return (
        <div className={styles.certificate} ref={certificateRef}>
            <h1 className={styles.name}>{userProfile?.first_name + " " + userProfile?.last_name}</h1>
            <p className={styles.date}>{new Date().toLocaleDateString()}</p>
            <p className={styles.certificate_id}>{userProfile?.id}</p>
        </div>
    );
}
